import { apiClient } from '@/lib/api';
import type { JobCategory, JobPriority, PlannerArea } from '@skewb-works/contracts';

export async function getPlannerJobCategories(): Promise<JobCategory[]> {
  return apiClient.get<JobCategory[]>('/jobs/job-categories');
}

export async function getPlannerJobPriorities(): Promise<JobPriority[]> {
  return apiClient.get<JobPriority[]>('/jobs/job-priorities');
}

/** Area options for the Schedule page's Area filter (SC-6251). */
export async function getPlannerAreas(): Promise<PlannerArea[]> {
  return apiClient.get<PlannerArea[]>('/works-lite/planner/areas');
}
